export default {
    "name": "getTrafficInformationFromAddress",
    "kind": "HoudiniQuery",
    "hash": "da01f284179f9b49c922a120e3c44c8fbb4d39e5c8866c29c6dbf69101e71d85",

    "raw": `query getTrafficInformationFromAddress($input: GetTrafficInformationFromAddressInput!) {
  getTrafficInformationFromAddress(input: $input) {
    listForSeo {
      count
      items {
        type
        description
        coordinates {
          lat
          lng
        }
      }
    }
    listForMap {
      count
      items {
        type
        description
        coordinates {
          lat
          lng
        }
        location
      }
    }
    nearbyCitiesHierarchies {
      label
      value
    }
    locationLocalizedHierarchies {
      locale
      hierarchy {
        label
        value
      }
    }
    cityHierarchy {
      label
      value
    }
    mapLocation {
      location {
        lat
        lng
      }
      viewPort {
        northeast {
          lat
          lng
        }
        southwest {
          lat
          lng
        }
      }
    }
    address {
      formattedAddress
      city
      country {
        code
      }
      department
      region
      zipCode
    }
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getTrafficInformationFromAddress": {
                "type": "TrafficInformationSuccessResultFromAddress",
                "keyRaw": "getTrafficInformationFromAddress(input: $input)",

                "selection": {
                    "fields": {
                        "listForSeo": {
                            "type": "TrafficInformationList",
                            "keyRaw": "listForSeo",

                            "selection": {
                                "fields": {
                                    "count": {
                                        "type": "Int",
                                        "keyRaw": "count",
                                        "visible": true
                                    },

                                    "items": {
                                        "type": "TrafficInformation",
                                        "keyRaw": "items",

                                        "selection": {
                                            "fields": {
                                                "type": {
                                                    "type": "TrafficInformationType",
                                                    "keyRaw": "type",
                                                    "visible": true
                                                },

                                                "description": {
                                                    "type": "String",
                                                    "keyRaw": "description",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "coordinates": {
                                                    "type": "Coordinates",
                                                    "keyRaw": "coordinates",
                                                    "nullable": true,

                                                    "selection": {
                                                        "fields": {
                                                            "lat": {
                                                                "type": "Float",
                                                                "keyRaw": "lat",
                                                                "visible": true
                                                            },

                                                            "lng": {
                                                                "type": "Float",
                                                                "keyRaw": "lng",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "listForMap": {
                            "type": "TrafficInformationList",
                            "keyRaw": "listForMap",

                            "selection": {
                                "fields": {
                                    "count": {
                                        "type": "Int",
                                        "keyRaw": "count",
                                        "visible": true
                                    },

                                    "items": {
                                        "type": "TrafficInformation",
                                        "keyRaw": "items",

                                        "selection": {
                                            "fields": {
                                                "type": {
                                                    "type": "TrafficInformationType",
                                                    "keyRaw": "type",
                                                    "visible": true
                                                },

                                                "description": {
                                                    "type": "String",
                                                    "keyRaw": "description",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "coordinates": {
                                                    "type": "Coordinates",
                                                    "keyRaw": "coordinates",
                                                    "nullable": true,

                                                    "selection": {
                                                        "fields": {
                                                            "lat": {
                                                                "type": "Float",
                                                                "keyRaw": "lat",
                                                                "visible": true
                                                            },

                                                            "lng": {
                                                                "type": "Float",
                                                                "keyRaw": "lng",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "location": {
                                                    "type": "String",
                                                    "keyRaw": "location",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "nearbyCitiesHierarchies": {
                            "type": "HierarchySegment",
                            "keyRaw": "nearbyCitiesHierarchies",

                            "selection": {
                                "fields": {
                                    "label": {
                                        "type": "String",
                                        "keyRaw": "label",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "locationLocalizedHierarchies": {
                            "type": "LocalizedHierarchy",
                            "keyRaw": "locationLocalizedHierarchies",

                            "selection": {
                                "fields": {
                                    "locale": {
                                        "type": "String",
                                        "keyRaw": "locale",
                                        "visible": true
                                    },

                                    "hierarchy": {
                                        "type": "HierarchySegment",
                                        "keyRaw": "hierarchy",

                                        "selection": {
                                            "fields": {
                                                "label": {
                                                    "type": "String",
                                                    "keyRaw": "label",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "value": {
                                                    "type": "String",
                                                    "keyRaw": "value",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "cityHierarchy": {
                            "type": "HierarchySegment",
                            "keyRaw": "cityHierarchy",

                            "selection": {
                                "fields": {
                                    "label": {
                                        "type": "String",
                                        "keyRaw": "label",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "mapLocation": {
                            "type": "MapLocation",
                            "keyRaw": "mapLocation",

                            "selection": {
                                "fields": {
                                    "location": {
                                        "type": "Coordinates",
                                        "keyRaw": "location",

                                        "selection": {
                                            "fields": {
                                                "lat": {
                                                    "type": "Float",
                                                    "keyRaw": "lat",
                                                    "visible": true
                                                },

                                                "lng": {
                                                    "type": "Float",
                                                    "keyRaw": "lng",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "viewPort": {
                                        "type": "CoordinateBounds",
                                        "keyRaw": "viewPort",

                                        "selection": {
                                            "fields": {
                                                "northeast": {
                                                    "type": "Coordinates",
                                                    "keyRaw": "northeast",

                                                    "selection": {
                                                        "fields": {
                                                            "lat": {
                                                                "type": "Float",
                                                                "keyRaw": "lat",
                                                                "visible": true
                                                            },

                                                            "lng": {
                                                                "type": "Float",
                                                                "keyRaw": "lng",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "southwest": {
                                                    "type": "Coordinates",
                                                    "keyRaw": "southwest",

                                                    "selection": {
                                                        "fields": {
                                                            "lat": {
                                                                "type": "Float",
                                                                "keyRaw": "lat",
                                                                "visible": true
                                                            },

                                                            "lng": {
                                                                "type": "Float",
                                                                "keyRaw": "lng",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "address": {
                            "type": "Address",
                            "keyRaw": "address",

                            "selection": {
                                "fields": {
                                    "formattedAddress": {
                                        "type": "String",
                                        "keyRaw": "formattedAddress",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "city": {
                                        "type": "String",
                                        "keyRaw": "city",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "country": {
                                        "type": "Country",
                                        "keyRaw": "country",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "code": {
                                                    "type": "String",
                                                    "keyRaw": "code",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "department": {
                                        "type": "String",
                                        "keyRaw": "department",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "region": {
                                        "type": "String",
                                        "keyRaw": "region",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "zipCode": {
                                        "type": "String",
                                        "keyRaw": "zipCode",
                                        "nullable": true,
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "GetTrafficInformationFromAddressInput"
        },

        "types": {
            "GetTrafficInformationFromAddressInput": {
                "addressEntityType": "AddressEntityType",
                "query": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=e68d01d184e84aa4487c341caba6449a1eb100c8b1de98cd3d1c5f74050c1b8c";